export default "__VITE_ASSET__CajjMMKu__"